import React from "react";
import { Container, Typography, Box, useTheme } from "@mui/material";
import DarkmodeToggle from "./DarkmodeToggle";
import PageSection from "../../components/PageSection";
import AccountSettings from "./AccountSettings";
import DeleteAccount from "./DeleteAccount";
import PasswordSettings from "./PasswordSettings";
import LanguageToggle from "./LanguageToggle";
import { T } from "../../components/T";

const SettingsPage = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        overflowY: "auto",
        bgcolor: theme.palette.background.default,
        py: 4,
      }}
    >
      <Container
        maxWidth="sm"
        sx={{
          color: theme.palette.text.primary,
          display: "flex",
          flexDirection: "column",
          gap: 4,
        }}
      >
        <Typography variant="h4" sx={{ fontWeight: 600 }}>
          <T str="Settings" />
        </Typography>

        <PageSection title={<T str="Appearance" />}>
          <DarkmodeToggle />
          <LanguageToggle />
        </PageSection>
        <PageSection title={<T str="Profile" />}>
          <AccountSettings />
        </PageSection>
        <PageSection title={<T str="Change password" />}>
          <PasswordSettings />
        </PageSection>
        <PageSection title={<T str="Delete account" />}>
          <DeleteAccount />
        </PageSection>
      </Container>
    </Box>
  );
};

export default SettingsPage;
